import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../utils/themes/ThemeProvider'

type Props = {
  size?: number | string
}

export const AuroraIndividualTherapySpotIllustration: FunctionComponent<Props> = ({ size = 96 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { spotIllustration } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 67 67' fill='none'>
      <Path
        d='M32.225 0.216064C27.8073 0.216064 23.5212 0.973625 19.4855 2.46725C9.87754 6.02867 3.12272 13.9243 0.952482 24.1292C-0.481698 30.7828 -0.298315 36.9369 1.51654 42.9342C3.83349 50.5932 9.52089 57.0521 17.1205 60.654C20.8932 62.4461 25.2273 63.4693 30.0003 63.6944C30.6137 63.7222 31.2372 63.7374 31.8569 63.7374C35.6865 63.7374 39.5388 63.2125 43.3076 62.178C43.5972 62.1059 43.8729 62.0313 44.1638 61.9453C47.5507 60.9537 50.5987 59.3855 53.2065 57.2899C56.0382 55.0273 58.369 52.159 60.127 48.7695C60.4735 48.1018 60.8049 47.3986 61.1704 46.5576C63.1813 41.8883 64.1525 36.6612 63.9805 31.4354C63.8996 29.1248 63.5556 26.6687 62.9612 24.1292C61.9823 20.0088 60.3862 16.1337 58.345 12.9163C57.786 12.0525 57.2725 11.3265 56.7641 10.6739C53.0952 5.94141 47.3787 2.62028 40.2382 1.0748C37.6151 0.505683 34.9188 0.217329 32.2262 0.217329L32.225 0.216064Z'
        fill='white'
        fillOpacity='0.4'
      />
      <Path
        d='M39.706 41.9262C34.6054 50.6236 22.3352 48.9908 14.666 47.3847C16.1596 47.028 17.929 46.3995 18.2224 44.8932C18.407 43.9421 17.9024 43.0151 17.5255 42.1222C13.1762 31.8414 24.3992 27.1063 32.7084 29.7243C39.7047 31.9274 42.3379 37.4403 39.706 41.9274V41.9262Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M27.9683 29.7977C35.4149 36.2186 46.5557 30.4768 53.3586 25.0917C45.3606 25.9049 49.696 17.8563 40.3081 13.8585C28.5564 8.85406 19.6604 22.6343 27.9683 29.7977Z'
        fill={spotIllustration.primary.fill}
      />
    </Svg>
  )
}
